import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { documentService } from "_services";
import { companyService } from "_services";

function Search(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [form] = Form.useForm();

  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);

    // Fetch exporters
    companyService
      .getSuggestion("")
      .then((response) => {
        setIsLoading(false);
        setCompanies(response.content || []);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching companines:", error);
      });
  }, []);

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "";

    /* if (values.linkType) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `linkType=${encodeURIComponent(values.linkType)}`;
    } */
    if (values.company) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `company=${encodeURIComponent(values.company)}`;
    }
    if (values.documentType) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `documentType=${encodeURIComponent(values.documentType)}`;
    }
    if (values.validFrom) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `validFrom=${encodeURIComponent(values.validFrom)}`;
    }
    if (values.validTo) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `validTo=${encodeURIComponent(values.validTo)}`;
    }

    // if (values.companyType) {
    //   searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
    //   searchParams += `companyType=${encodeURIComponent(values.companyType)}`;
    // }

    documentService
      .search(searchParams)
      .then((data) => {
        props.onSearchResults(
          data.content,
          data.pagination.totalRecords,
          searchParams
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([], null, searchParams);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        {/* <Col span={6}>
          <Form.Item name="linkType" label="Link Type">
            <Select placeholder="Please select" allowClear>
              {DocumentLinkType.map((age) => (
                <Select.Option value={age.value} key={age.value}>
                  {age.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col> */}
        <Col span={6}>
          <Form.Item name="company" label="Company">
            <Select
              placeholder="Select Company"
              allowClear
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              loading={isLoading}
            >
              {companies.map((company) => (
                <Option value={company.id} key={company.id}>
                  {company.name || company.companyName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name={["validFrom"]} label="Valid From">
            <DatePicker
              placeholder="Valid From"
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col span={5}>
          <Form.Item name={["validTo"]} label="Valid To">
            <DatePicker
              placeholder="Valid To"
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default Search;
